import { GameConstants } from "../GameConstants";
import { GameManager } from "../GameManager";
import { GameVars } from "../GameVars";

export class PreLoader extends Phaser.State {

    public static currentInstance: PreLoader;

    private scaledItemsContainer: Phaser.Group;

    private preloadBar: Phaser.Sprite;
    
    public init(): void {
        
        PreLoader.currentInstance = this;
    }
    
    public preload(): void {

        Phaser.Canvas.setBackgroundColor(this.game.canvas, "#000000");

        this.generateBitmapData();
        this.composeScene();
        this.loadAssets();
    }

    public create(): void {

        let delay = GameConstants.DEVELOPMENT ? 50 : 150;

        this.game.time.events.add(delay, function(): void {
            GameManager.onGameAssetsLoaded();
        }, this);
    }
    
    public shutdown(): void {
        
        PreLoader.currentInstance = null;
        
        super.shutdown();
    }

    private updateLoadedPercentage(): void {

        this.preloadBar.scale.x = this.load.progress / 100 * 5.94;

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIX) {

            GamePix.game.gameLoading(this.load.progress);
        }
    }

    private generateBitmapData(): void {

        let bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.BLACK_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#000000";
        bmd.ctx.fill();
        
        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.WHITE_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#FFFFFF";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.RED_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#FF0000";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.ORANGE_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#FF9900";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.YELLOW_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#FFFF00";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.GREEN_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#00FF00";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.GREY_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#cccccc";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.DARK_GREY_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#666666";
        bmd.ctx.fill();
    }

    private composeScene(): void {

        this.add.text(0, 0, "abcdefghi", {font: "56px JustAnotherFont", fill: "#000000"});
        this.add.text(0, 0, "abcdefghi", {font: "56px RoundsBlack", fill: "#000000"});

        let px = 103 / 2; // 103 es el ancho de la imagen

        for (let i = 0; i < 8; i ++) {
            
            const tile = this.add.image(px, 0, "lawn-tile");
            tile.anchor.x = .5;
            if (Math.random() > 0) {
                tile.scale.x = -1;
            }
            px += (Math.abs(tile.width) - .5);
        }

        this.scaledItemsContainer = this.add.group();
        this.scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        this.scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        this.scaledItemsContainer.scale.x = GameVars.scaleX;

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
            const logoLagged = new Phaser.Image(this.game, 0, -45, "logo-lagged");
            logoLagged.anchor.set(.5);
            logoLagged.scale.set(1.15);
            this.scaledItemsContainer.add(logoLagged);
        }
        
        const preloadBarCapsuleShadow = new Phaser.Sprite(this.game, 1.5, 71.5, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
        preloadBarCapsuleShadow.scale.set(6, .2);
        preloadBarCapsuleShadow.anchor.set(.5);
        preloadBarCapsuleShadow.alpha = .75;
        this.scaledItemsContainer.add(preloadBarCapsuleShadow);

        const preloadBarCapsule = new Phaser.Sprite(this.game, 0, 70, this.game.cache.getBitmapData(GameConstants.WHITE_SQUARE));
        preloadBarCapsule.scale.setTo(6, .2);
        preloadBarCapsule.anchor.set(.5);
        this.scaledItemsContainer.add(preloadBarCapsule);

        this.preloadBar = new Phaser.Sprite(this.game, -190.2, 70, this.game.cache.getBitmapData(GameConstants.RED_SQUARE));
        this.preloadBar.scale.setTo(0, .15);
        this.preloadBar.anchor.set(0, .5);
        this.scaledItemsContainer.add(this.preloadBar);
    }
    
    private loadAssets(): void {

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
        
        // AUDIO
        this.load.audiosprite("audio-sprite", ["assets/audio/audiosprite.mp3", "assets/audio/audiosprite.ogg"], "assets/audio/audiosprite.json");

        this.load.onFileComplete.add(this.updateLoadedPercentage, this);
    }
}
